export default __webpack_public_path__ + "static/media/Defaulted.7d9bcdbd.svg";